import React, { useState, useCallback, useEffect } from "react";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import api from "../../../services/api";
import ProjectDetails from "./EMPSections/ProjectDetails";
import Navbar from "../../../components/Navbar";

const EMP = () => {
  const [userRole, setUserRole] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  const [empFormData, setEmpFormData] = useState({
    projectDetails: {
      projectName: "",
    },
  });

  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const userData = JSON.parse(localStorage.getItem("user"));
        if (userData && userData.role) {
          setUserRole(userData.role);
        }
      } catch (error) {
        console.error("Error fetching user role:", error);
      }
    };
    fetchUserRole();
  }, []);
  const role = userRole;

  const handleFormDataChange = useCallback((section, data) => {
    setEmpFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        ...data,
      },
    }));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const urlParams = new URLSearchParams(window.location.search);
    const projectId = urlParams.get("projectId");

    if (!projectId) {
      toast.error("Missing project ID. Please start from the project page.");
      return;
    }

    try {
      const loadingToast = toast.info("Generating document, please wait...", {
        autoClose: false,
      });

      // Save EMP document
      await api.post("/api/emp", {
        projectId: projectId,
        title:
          empFormData.projectDetails.projectName ||
          "Environment Management Plan",
        content: empFormData,
      });

      // Generate EMP document with proper error handling
      const response = await api.post("/generate-emp", empFormData, {
        responseType: "blob",
        headers: {
          Accept:
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        },
      });

      // Check if response contains valid data
      if (response.data.size === 0) {
        throw new Error("Generated document is empty");
      }

      // Create a filename for the document
      const filename = `EMP_${
        empFormData.projectDetails.projectName || "Document"
      }_${new Date().toISOString().slice(0, 10)}.docx`;

      // Create blob and trigger download
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      saveAs(blob, filename);

      toast.dismiss(loadingToast);
      toast.success("Document generated and saved successfully!");
      window.history.back();
    } catch (error) {
      console.error("Error generating document:", error);
      toast.error("Failed to generate document. Please try again.");
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <ProjectDetails
            empFormData={empFormData}
            setEmpFormData={handleFormDataChange}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
          />
        );
      case 2:
        return <div>Step 2 Content</div>;
      case 3:
        return <div>Step 3 Content</div>;
      case 4:
        return <div>Step 4 Content</div>;
      case 5:
        return <div>Step 5 Content</div>;
      case 6:
        return <div>Step 6 Content</div>;
      case 7:
        return <div>Step 7 Content</div>;
      case 8:
        return <div>Step 8 Content</div>;
      case 9:
        return <div>Step 9 Content</div>;
      default:
        return null;
    }
  };

  return (
    <div className="caf-container">
      <Navbar role={role} />
      <div className="step-indicator">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((step) => (
          <div
            key={step}
            className={`step ${currentStep === step ? "active" : ""} 
                     ${currentStep > step ? "completed" : ""}`}
            onClick={() => setCurrentStep(step)}
          >
            <div className="step-number">{step}</div>
            <div className="step-label">
              {step === 1}
              {step === 2}
              {step === 3}
              {step === 4}
              {step === 5}
              {step === 6}
              {step === 7}
              {step === 8}
              {step === 9}
            </div>
          </div>
        ))}
      </div>
      <h1>Environment Managment Plan</h1>
      <form className="emp-form" onSubmit={handleSubmit}>
        {renderStep()}
        <div className="form-navigation">
          {currentStep > 1 && (
            <button
              type="button"
              onClick={() => setCurrentStep((prev) => prev - 1)}
              className="prev-btn"
            >
              Previous
            </button>
          )}
          {currentStep < 9 && (
            <button
              type="button"
              onClick={() => setCurrentStep((prev) => prev + 1)}
              className="next-btn"
            >
              Next
            </button>
          )}
          {currentStep === 9 && (
            <button type="submit" className="submit-btn">
              Submit
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default EMP;
